// extracted by mini-css-extract-plugin
export var filterIncDec = "_b6-0";
export var leftBorder = "_b6-1";
export var rightBorder = "_b6-2";
export var stringInput = "_b6-3";